<template>
  <div class="col-12 row q-col-gutter-x-sm items-center">
    <model-form-select
      :field="`conditionsRequirements.${lifetimeTermField}`"
      class="col-12"
      label="Lifetime Term"
      value-type="String"
      :options="$mh.asOptions(['days', 'months', 'years'])"
      map-options
      emit-value
      :rules="[val => !!val || 'Field is required']"
    />
    <model-form-input
      :field="`conditionsRequirements.${lifetimeMinimumField}`"
      class="col-6"
      :label="`Minimum ${$_.startCase(conditional.conditionsRequirements[lifetimeTermField])} ${conditional.membershipType?.name ? 'As ' + conditional.membershipType.name : ''}`"
      type="number"
      value-type="Number"
      step="1"
      min="0"
      :rules="[val => $_.isNumber(val) && val >= 0 || 'Field is required']"
    />
    <model-form-input
      :field="`conditionsRequirements.${lifetimeMaximumField}`"
      class="col-6"
      :label="`Maximum ${$_.startCase(conditional.conditionsRequirements[lifetimeTermField])} ${conditional.membershipType?.name ? 'As ' + conditional.membershipType.name : ''}`"
      type="number"
      value-type="Number"
      step="1"
      min="1"
      :rules="[val => $_.isNumber(val) && val >= conditional.conditionsRequirements[lifetimeMinimumField] || 'Field must be greater than Lifetime Minimum']"
    />
  </div>
</template>

<script>
import { CONDITION_REQUIREMENTS } from 'src/models/membership-type/MembershipPoint'

export default {
  name: 'LifetimeConditionForm',
  props: {
    conditional: {
      type: Object,
      required: true
    },
    lifetimeTermField: {
      type: String,
      default: CONDITION_REQUIREMENTS.LIFETIME_TERM
    },
    lifetimeMinimumField: {
      type: String,
      default: CONDITION_REQUIREMENTS.LIFETIME_MINIMUM
    },
    lifetimeMaximumField: {
      type: String,
      default: CONDITION_REQUIREMENTS.LIFETIME_MAXIMUM
    }
  }
}

</script>
